<template>
	<label :for="`range-${name}`">
		<span class="font-size-big ink-base semi-bold display-block margin-vertical-normal">Valor</span>
		<div class="input-wrapper margin-top-normal">
			<div class="display-flex justify-content-center">
				<span class="align-center font-size-big ink-lighter-1 regular margin-bottom-normal"
					>{{ toCurrency(valueMin) }} - {{ toCurrency(valueMax) }}</span
				>
			</div>
			<div class="display-flex margin-top-normal">
				<span class="multi-range font-size-big">
					<input
						type="range"
						:min="min"
						:max="max"
						v-model="valueMin"
						@input="e => updateMinValue(e)"
					/>
					<input
						type="range"
						:min="min"
						:max="max"
						v-model="valueMax"
						@input="e => updateMaxValue(e)"
					/>
				</span>
			</div>
		</div>
	</label>
</template>

<script>
export default {
	name: 'b-range',
	data() {
		return {
			valueMin: this.selectedMin,
			valueMax: this.selectedMax
		};
	},
	props: {
		/**
		 * Name padrão do range
		 */
		name: {
			type: String,
			required: true
		},
		/**
		 * Valor mínimo do range
		 */
		min: {
			type: Number,
			required: true
		},
		/**
		 * Valor máximo do range
		 */
		max: {
			type: Number,
			required: true
		},
		/**
		 * Valor mínimo selecionado do range
		 */
		selectedMin: {
			type: Number,
			required: true
		},
		/**
		 * Valor máximo selecionado do range
		 */
		selectedMax: {
			type: Number,
			required: true
		}
	},
	watch: {
		selectedMin: function() {
			this.valueMin = this.selectedMin;
		},
		selectedMax: function() {
			this.valueMax = this.selectedMax;
		}
	},
	methods: {
		/**
		 * Máscara de valor monetário
		 */
		toCurrency(number) {
			let value = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
			return 'R$' + value + ',00';
		},
		/**
		 * Evento de mudança do valor mínimo
		 */
		updateMinValue(event) {
			if (event.target.value >= Number(this.valueMax)) this.valueMin = Number(this.valueMax) - 10;
			this.$emit('input', {
				min: Number(this.valueMin),
				max: Number(this.valueMax)
			});
		},
		/**
		 * Evento de mudança do valor máximo
		 */
		updateMaxValue(event) {
			if (event.target.value <= Number(this.valueMin)) this.valueMax = Number(this.valueMin) + 10;
			this.$emit('input', {
				min: Number(this.valueMin),
				max: Number(this.valueMax)
			});
		}
	},
	mounted() {
		this.$emit('input', {
			min: Number(this.valueMin),
			max: Number(this.valueMax)
		});
	}
};
</script>

<style scoped lang="scss">
.input-wrapper {
	width: 100%;
}

input[type='range'] {
	box-sizing: border-box;
	appearance: none;
	width: 100%;
	margin: 0;
	height: 8px;
	border-radius: 5px;
	outline: none;
	background: linear-gradient(#807b91, #807b91) no-repeat center;
	background-size: 100%;
	pointer-events: none;

	&:active,
	&:focus {
		outline: none;
	}

	&::-webkit-slider-thumb {
		height: 32px;
		width: 32px;
		border-radius: 28px;
		background-color: #fff;
		position: relative;
		margin: 5px 0;
		/* Add some margin to ensure box shadow is shown */
		cursor: pointer;
		appearance: none;
		pointer-events: all;
		box-shadow: 0px 2px 2px #00000024;
		border: 1px solid #dcdbe1;
		&::before {
			content: ' ';
			display: block;
			position: absolute;
			top: 13px;
			left: 100%;
			width: 2000px;
			height: 2px;
		}
	}
}

.multi-range {
	position: relative;
	height: 50px;
	width: 100%;

	input[type='range'] {
		position: absolute;

		&:nth-child(1) {
			&::-webkit-slider-thumb::before {
				background-color: grey;
			}
		}

		&:nth-child(2) {
			background: none;

			&::-webkit-slider-thumb::before {
				background-color: grey;
			}
		}
	}
}
</style>

<docs>
    Range
    ```js 
    <b-range name="range"
        :min="minValue" 
        :max="maxValue" 
        :selectedMin="range.min" 
        :selectedMax="range.max" 
        v-model="range" >
        
        <div slot="label">
          <p>Valor</p>
        </div>
    </b-range>
    ```
</docs>
